module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-form-item",
    class: {
      'is-error': _vm.validateState === 'error',
        'is-validating': _vm.validateState === 'validating',
        'is-required': _vm.isRequired || _vm.required
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "el-form-item-label",
    style: (_vm.labelStyle)
  }, [_vm._v("\n          " + _vm._s(_vm.label + _vm.form.labelSuffix) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-form-item-content",
    style: (_vm.contentStyle)
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "md-fade-bottom"
    }
  }, [(_vm.validateState === 'error') ? _c('div', {
    staticClass: "el-form-item-error"
  }, [_vm._v(_vm._s(_vm.validateMessage))]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-beaff37a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/src/form-item.vue
// module id = 679
// module chunks = 0